import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { doAddFavorite, doDelFavorite } from '../../actions/favorites';
import useMergeProps from '../../hooks/useMergeProps';
import useTypedSelector from '../../hooks/useTypedSelector';

import MatchCardHeader from './MatchCardHeader';
import makeMatchCardHeaderPropsSelector from './MatchCardHeader.selector';

type MatchCardHeaderContainerProps = {
  className?: string;
  matchId: number;
  startDate: number | null;
  tvChannel: string | null;
  sportId: number;
  categoryId: number;
  isLive?: boolean;
  isOutright?: boolean;
  cardBadgeHasAttach?: boolean;
  periodName?: string;
};

const MatchCardHeaderContainer = (ownProps: MatchCardHeaderContainerProps) => {
  const { matchId, isOutright } = ownProps;
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ matchId, isOutright }), [matchId, isOutright]);
  const selector = useMemo(() => makeMatchCardHeaderPropsSelector(), []);
  const selectedProps = useTypedSelector((state) => selector(state, selectorProps));

  const onFavoriteButtonClicked = useCallback(
    (isFavorite: boolean) => {
      if (isFavorite) {
        dispatch(doDelFavorite({ matchId }));
      } else {
        dispatch(doAddFavorite({ matchId }));
      }
    },
    [dispatch, matchId],
  );

  const otherProps = useMemo(
    () => ({
      onFavoriteButtonClicked,
    }),
    [onFavoriteButtonClicked],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MatchCardHeader {...enhancedProps} />;
};

export default MatchCardHeaderContainer;
